export default __webpack_public_path__ + "static/circle1-ce40a5de30787bf593e491cec7ec24bc.png";